import type { PageInfo, TextMaterial } from '@@partner:types:app'
import type {
  CommonPager,
  NestedFilter,
  CommonSort
} from '@@partner:types:graphql'

import { gql, useLazyQuery, useQuery } from '@apollo/client'

import { SHORTCUT_PAGE_INFO_FIELDS } from '@@partner:graphql/shortcuts'
import { SHORTCUT_TEXT_MATERIAL_FIELDS } from '../textMaterialShortcut'

export interface AllTextMaterialsQuery {
  allTextMaterials: {
    edges: TextMaterial[]
    pageInfo: PageInfo
  }
}
export interface AllTextMaterialsQueryVariables {
  filter?: NestedFilter
  sort?: CommonSort
  pager: CommonPager
}

export const GQL_QUERY_ALL_BUSINESS_PROFILES = gql`
  query (
    $filter: NestedFilterInput
    $pager: CommonPagerInput
    $sort: CommonSortInput
  ) {
    allTextMaterials(
      filter: $filter
      sort: $sort
      pager: $pager
    ) {
      edges {
        ${SHORTCUT_TEXT_MATERIAL_FIELDS}
      }
      pageInfo {
        ${SHORTCUT_PAGE_INFO_FIELDS}
      }
    }
  }
`

export const useFetchAllTextMaterials = (variables: AllTextMaterialsQueryVariables) =>
  useQuery<AllTextMaterialsQuery, AllTextMaterialsQueryVariables>(
    GQL_QUERY_ALL_BUSINESS_PROFILES,
    {
      variables,
      fetchPolicy: 'cache-and-network'
    }
  )

export const useLazyFetchAllTextMaterials = (variables?: AllTextMaterialsQueryVariables) => 
  useLazyQuery<AllTextMaterialsQuery, AllTextMaterialsQueryVariables>(GQL_QUERY_ALL_BUSINESS_PROFILES, {
    variables
  })